import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { ContestStatusModule } from '@freelancer/contest-status';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { EntryUpdateErrorComponent } from './contest-entries-tab/entry-update-error/entry-update-error.component';
import { ContestViewChallengeNavigationCardComponent } from './contest-view-header/enterprise-header/contest-view-challenge-navigation/contest-view-challenge-navigation-card.component';
import { ContestViewChallengeNavigationComponent } from './contest-view-header/enterprise-header/contest-view-challenge-navigation/contest-view-challenge-navigation.component';
import { ContestViewHeroBannerChallengeComponent } from './contest-view-header/enterprise-header/contest-view-hero-banner-challenge/contest-view-hero-banner-challenge.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    ContestStatusModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    ContestViewChallengeNavigationCardComponent,
    ContestViewChallengeNavigationComponent,
    ContestViewHeroBannerChallengeComponent,
    EntryUpdateErrorComponent,
  ],
  exports: [
    ContestViewChallengeNavigationCardComponent,
    ContestViewChallengeNavigationComponent,
    ContestViewHeroBannerChallengeComponent,
    EntryUpdateErrorComponent,
  ],
})
export class ContestViewSharedModule {}
